import Cookies from "js-cookie";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// Rooms - Get All (Read)
export const GetAllRooms = createAsyncThunk(
    "masters/rooms/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Masters.Rooms}?term=${filter?.name || ""}&room_type=${filter?.roomType || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Rooms - Get (Read)
export const GetSingleRoom = createAsyncThunk(
    "masters/rooms/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Masters.Rooms}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Rooms - Create (Add)
export const CheckAvailability = createAsyncThunk(
    "masters/rooms/CheckAvailability",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.RB.CheckAvailibility}/${id}?check_in_date=${data?.check_in_date}&check_out_date=${data?.check_out_date}&check_in_time=${data?.check_in_time}&check_out_time=${data?.check_out_time}`);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);// The new rooms object
        } catch (error) {
            console.log(error, 'error');

            return rejectWithValue(error);
        }
    }
);

export const CalculateTHEFukingRoom = createAsyncThunk(
    "masters/rooms/book-room",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.RB.BookRoom}/calculate/${id}`, data);
            if (res?.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);
export const BookTHEFukingRoom = createAsyncThunk(
    "masters/rooms/book-room",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.RB.BookRoom}/${id}`, data);
            if (res?.success) {

                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);


export const getBookingDetail = createAsyncThunk(
    "masters/rooms/getBookingDetail",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.RB.BookRoom}/${id}`);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);// The new rooms object
        } catch (error) {

            return rejectWithValue(error);
        }
    }
);

// Rooms - CancelBooking
export const CancelBooking = createAsyncThunk(
    "masters/rooms/cancelBooking",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.RB.BookRoom}/${id}`, data);
            if (res?.success) {
                return res;

            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Rooms - Delete
export const Delete = createAsyncThunk(
    "masters/rooms/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${APIS.Masters.App_Setup} / ${id}`);
            return id; // Return the id of the deleted rooms
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Rooms - Status
export const Status = createAsyncThunk(
    "masters/rooms/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.App_Setup} / ${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "rooms",
    initialState: {
        data: [],
        single_room: {},
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, CancelBooking, Delete
            .addCase(GetAllRooms.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllRooms.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllRooms.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingleRoom.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingleRoom.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.single_room = action.payload?.data || [];
            })
            .addCase(GetSingleRoom.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(CheckAvailability.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(CheckAvailability.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(CheckAvailability.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(getBookingDetail.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(getBookingDetail.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(getBookingDetail.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(CancelBooking.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(CancelBooking.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (rooms) => rooms.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(CancelBooking.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (rooms) => rooms.id !== action.payload.id
                ); // Remove the rooms with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (rooms) => rooms.id !== action.payload.id
                ); // Remove the rooms with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
